module.exports = __webpack_public_path__ + "assets/icon_relational_matching.6e2569f6.svg";